<template>
  <div>
    <ServicesCard
      cardHeadline="Oversikt over dine saker"
      v-model="services"
    ></ServicesCard>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { mapGetters } from "vuex";

import complaintApi from "@/api/complaintApi";
import taskApi from "@/api/taskApi";
import aberrationApi from "@/api/aberrationApi";
import checkListApi from "@/api/checkListApi";

import ServicesCard from "@/components/shared/cards/ServicesCard.vue";

export default Vue.extend({
  name: "DashboardShortcuts",
  data() {
    return {
      countComplaints: 0,
      countEnquiry: 0,
      countActions: 0,
      countCheckups: 0,
      countChecklists: 0,
    };
  },
  mounted() {
    var headersEnquiry = [
      {
        text: "isEnquiry",
        value: "isEnquiry",
        type: "boolean",
        show: false,
        filterValues: ["true"],
        filterClause: 0,
        filterName: "isEnquiry",
        removeFilter: true,
      },
      {
        text: "Status",
        value: "regStatus",
        type: "int",
        show: true,
        filterValues: [0, 1, 4, 6, 7],
        filterClause: 0,
        filterName: "lineStatus",
        sortable: false,
      },
      {
        text: "Ansvarlig",
        value: "contactPersonName",
        type: "string",
        show: true,
        filterValues: [this.profile.id],
        filterClause: 0,
        filterName: "contactPersonOid",
      },
    ];
    var headersComplaints = [
      {
        text: "isEnquiry",
        value: "isEnquiry",
        type: "boolean",
        show: false,
        filterValues: ["false"],
        filterClause: 0,
        filterName: "isEnquiry",
        removeFilter: true,
      },
      {
        text: "Status",
        value: "regStatus",
        type: "int",
        show: true,
        filterValues: [0, 1, 4, 6, 7],
        filterClause: 0,
        filterName: "lineStatus",
        sortable: false,
      },
      {
        text: "Ansvarlig",
        value: "contactPersonName",
        type: "string",
        show: true,
        filterValues: [this.profile.id],
        filterClause: 0,
        filterName: "contactPersonOid",
      },
    ];

    var headersCheckups = [
      {
        text: "Type",
        value: "taskType",
        type: "string",
        show: false,
        filterValues: ["2"],
        filterClause: 0,
        filterName: "taskType",
        removeFilter: true,
      },
      {
        text: "Ferdigmeld",
        value: "isCompleted",
        type: "boolean",
        show: true,
        filterValues: ["false"],
        filterClause: 0,
        filterName: "isCompleted",
      },
      {
        text: "Ansvarlig",
        value: "assignedTo",
        type: "string",
        show: true,
        filterValues: [this.profile.id],
        filterClause: 0,
        filterName: "assignedToId",
      },
    ];

    var headersActions = [
      {
        text: "Status",
        value: "statusText",
        type: "string",
        show: true,
        filterValues: [1],
        filterClause: 0,
        filterName: "actionStatus",
        sortIndex: 2,
      },
      {
        text: "Ansvarlig",
        value: "responsible",
        type: "string",
        show: true,
        filterValues: [this.profile.id],
        filterClause: 0,
        filterName: "responsibleId",
      },
    ];

    var headersChecklists = [
      {
        text: "Fullført",
        value: "isCompleted",
        type: "boolean",
        show: true,
        filterValues: ["false"],
        filterClause: 0,
        filterName: "isCompleted",
      },
      {
        text: "Ansvarlig",
        value: "assignedTo",
        type: "string",
        show: true,
        filterValues: [this.profile.id],
        filterClause: 0,
        filterName: "assignedContactPersonId",
      },
    ];

    complaintApi
      .getComplaintsCount({
        headers: headersEnquiry,
        hideLoader: true,
      })
      .then((response) => {
        this.countEnquiry = response;
      });
    complaintApi
      .getComplaintsCount({
        headers: headersComplaints,
        hideLoader: true,
      })
      .then((response) => {
        this.countComplaints = response;
      });
    taskApi
      .getTaskCount({
        headers: headersCheckups,
        hideLoader: true,
      })
      .then((response) => {
        this.countCheckups = response;
      });

    aberrationApi
      .getActionsCount({
        headers: headersActions,
        hideLoader: true,
      })
      .then((response) => {
        this.countActions = response;
      });

    checkListApi
      .getChecklistsCount({
        headers: headersChecklists,
        hideLoader: true,
      })
      .then((response) => {
        this.countChecklists = response;
      });
  },
  computed: {
    ...mapGetters({
      profile: "shared/profile",
      isTrysilhus: "shared/isTrysilhus",
    }),
    services(): Array<any> {
      var services = [
        {
          icon: "mdi-clipboard-alert-outline",
          title: "Reklamasjoner",
          to: "Complaints",
          count: this.countComplaints,
        },
        {
          icon: "mdi-hammer-wrench",
          title: "Tiltak",
          to: "Actions",
          count: this.countActions,
        },
        {
          icon: "mdi-message-text-outline",
          title: "Henvendelser",
          to: "Requests",
          count: this.countEnquiry,
        },
        {
          icon: "mdi-account-check-outline",
          title: "Egenkontroller",
          to: "Checkups",
          count: this.countCheckups,
        },
      ];

      if (this.isTrysilhus) {
        services.push({
          icon: "mdi-order-bool-ascending-variant",
          title: "Sjekklister",
          to: "Checklists",
          count: this.countChecklists,
        });
      }

      return services;
    },
  },
  components: {
    ServicesCard,
  },
});
</script>
